module.exports = __webpack_public_path__ + "img/Balkon01.411df6c6.webp";